import(/* webpackMode: "eager" */ "/repo/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/repo/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSuggestion"] */ "/repo/apps/web/src/components/i18n/LocaleSuggestion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeadHandoffDelivery"] */ "/repo/apps/web/src/lib/adPixels/LeadHandoffDelivery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.2_@babel+core@7.29.7_48c2aa4e392fab81a67bfbfb490b8957/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.64.0_@types+_6ef4de6ad1fe77ea959f26435e510fcb/node_modules/next/dist/client/script.js");
